module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.systems), function(system, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "xs3": ""
      }
    }, [_c('v-card', [_c('v-card-title', {
      attrs: {
        "primary": ""
      }
    }, [_vm._v(_vm._s(system.title))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('div', [_c('pie-chart', {
      attrs: {
        "chart-data": system,
        "options": _vm.options
      }
    })], 1)])], 1)], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-716c553d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/SystemStorageReport.vue
// module id = 1084
// module chunks = 1